module.exports = __webpack_public_path__ + "static/media/salade.97395143.svg";